import { render, staticRenderFns } from "./fzlc.vue?vue&type=template&id=61575ea2&"
import script from "./fzlc.vue?vue&type=script&lang=js&"
export * from "./fzlc.vue?vue&type=script&lang=js&"
import style0 from "./fzlc.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports